import JanusContent from "./JanusContent";

export default JanusContent;
